module.exports = __webpack_public_path__ + "media/assets/images/payments/ebanx-5c422a52518b3dd79dcd3f15180ada36.png";